document.addEventListener('DOMContentLoaded', function () {

  $('.videogrid-slider').slick({
    slidesToShow: 4,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 400,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          centerPadding: '20%'
        }
      }
    ]
  });

  $('.productslider-ingredients').slick({ 
    slidesToShow: 3,
    arrows: false,
    dots: true,
    infinite: false,
    speed: 400,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

   $('.reviewslider-section').slick({ 
    slidesToShow: 3,
    arrows: false,
    dots: true,
    infinite: false,
    speed: 400,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  /* Click play / pause */
  document.querySelectorAll('.grid-video').forEach(video => {
    video.addEventListener('click', function () {

      // Pause all other videos
      document.querySelectorAll('.grid-video').forEach(v => {
        if (v !== video) v.pause();
      });

      video.paused ? video.play() : video.pause();
    });
  });

}); 

 
document.addEventListener('DOMContentLoaded', function () {
  const video = document.getElementById('customVideo');
  if (!video) return;

  video.addEventListener('click', function () {
    video.paused ? video.play() : video.pause();
  });
}); 

$(".accordion-heading, .faq-heding").click(function(){
  if($(this).hasClass("active")){
    $(this).removeClass("active");
  }else{
    $(this).addClass("active")
  }
})


$(".tabingsection-faq button").click(function(){

  var dataValue = $(this).data("value");

  $(".tabingsection-faq button").removeClass("active");
  $(this).addClass("active");
  $(".tabing-content-section").hide();
  $(`.tabing-content-section[data-text="${dataValue}"]`).show();
  

})


